module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0127-mshikaku/mshikaku.component.css
// module id = ./src/app/a0127-mshikaku/mshikaku.component.css
// module chunks = main